// src/components/ExportButtons.js

import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import { CSVLink } from 'react-csv';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GetAppIcon from '@mui/icons-material/GetApp';
import PropTypes from 'prop-types';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const ExportButtons = ({ data }) => {
  // Define headers for CSV
  const headers = [
    { label: 'ID', key: 'id' },
    { label: 'Name', key: 'name' },
    { label: 'Date', key: 'date' },
    { label: 'Status', key: 'status' },
  ];

  // Flatten data if it's nested
  const csvData = data.flatMap(record =>
    record.records.map(student => ({
      id: student.id,
      name: student.name,
      date: record.date,
      status: student.status,
    }))
  );

  // PDF Export Handler
  const handleExportPDF = (attendanceData) => {
    const doc = new jsPDF();

    doc.text('Attendance Report', 14, 16);
    doc.setFontSize(12);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 22);

    const tableColumn = ["ID", "Name", "Date", "Status"];
    const tableRows = [];

    attendanceData.forEach(record => {
      record.records.forEach(student => {
        const studentData = [
          student.id,
          student.name,
          record.date,
          student.status,
        ];
        tableRows.push(studentData);
      });
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
    });

    doc.save(`attendance_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  // Listen for custom event to trigger PDF export
  useEffect(() => {
    const handlePDFExport = (e) => {
      handleExportPDF(e.detail);
    };

    window.addEventListener('export-pdf', handlePDFExport);

    return () => {
      window.removeEventListener('export-pdf', handlePDFExport);
    };
  }, [data]);

  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
      {/* CSV Export Button */}
      <CSVLink
        data={csvData}
        headers={headers}
        filename={`attendance_${new Date().toISOString().split('T')[0]}.csv`}
        style={{ textDecoration: 'none' }}
      >
        <Button variant="contained" color="primary" startIcon={<GetAppIcon />}>
          Export CSV
        </Button>
      </CSVLink>

      {/* PDF Export Button */}
      <Button
        variant="contained"
        color="secondary"
        startIcon={<PictureAsPdfIcon />}
        onClick={() => window.dispatchEvent(new CustomEvent('export-pdf', { detail: data }))}
      >
        Export PDF
      </Button>
    </div>
  );
};

ExportButtons.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          status: PropTypes.oneOf(['Present', 'Absent']).isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default ExportButtons;
